module.exports = __webpack_public_path__ + "img/map-visual-page-management.cb41f61a.svg";